<template>
  <div class="graduation">
    <img  src="~@/assets/vote/banner2.png" class="competition-img"  @click="handleClickToSign(3)">

    <div class="grad-content">
      <div class="title">
        <div class="title-letter"><span class="first">O</span>BJECTIVES</div>
        <div class="title-sub"><span>活动目的<img src="~@/assets/img/sign/you.svg" height="24"/></span><span class="line"></span><span class="number">01</span></div>
      </div>
      <div class="content1">
        <div class="left">
          <video controls="controls" autoplay="autoplay" loop="loop" style="width:755px;margin: 0 auto;">
            <source :src="videoUrl" type="video/mp4">
            您的浏览器不支持视频播放
          </video>
        </div>
        <div class="right">
          面向全国高等院校工艺美术专业应届毕业生，汇聚优质创新创意作品，展现全国院校当代工艺美术创意设计实力;促进国内院校间工艺美术学科交流，提升设计教育水平，推动产学融合，培育新生代文化创意设计力量;探讨工艺美术创新思路，建立国家级的工艺美术创意产品成果展示、评价、推广和支撑体系，通过征集创新作品的方式，发现和推介优秀作品和人才，围绕“创意工美”和“科技工美”两个主题进行遴选和推荐优秀作品，提升学生创作和教学品质，扩大学会的影响力。
        </div>
      </div>
      <div class="title">
        <div class="title-letter"><span class="first">O</span>RGANIZATIONAL STRUCTURE</div>
        <div class="title-sub"><span>组织机构<img src="~@/assets/img/sign/you.svg" height="24"/></span><span class="line"></span><span class="number">02</span></div>
      </div>
      <div class="content2">
        <div class="text">
          中国工艺美术学会(China National Arts& Crafts Society，CNACS)成立于1965年，是由中国科学技术协会主管，是全国工艺美术科技、艺术工作者自愿结合并依法登记的学术性、公益性、非营利的社会团体，接受中国轻工业联合会工作指导、中华人民共和国民政部监督管理
        </div>
        <div class="list-img">
          <span>
            <img src="~@/assets/img/sign/xuehui.png" height="80" alt="Logo">
            <div>主办单位</div>
          </span>
          <span>
            <img src="~@/assets/img/sign/weiyuanhui.png" height="80" alt="Logo">
            <div>协办单位</div>
          </span>
        </div>
      </div>

      <div class="title">
        <div class="title-letter"><span class="first">C</span>OMPETITION TIMELINE</div>
        <div class="title-sub"><span>大赛进程<img src="~@/assets/img/sign/you.svg" height="24"/></span><span class="line"></span><span class="number">03</span></div>
      </div>
      <div class="content3">
        <div class="center">
          <img src="~@/assets/img/sign/saishi1.svg" >
        </div>
      </div>
    </div>

    <div class="backgroundFF">
      <div class="grad-con">
        <div class="title">
          <div class="title-letter"><span class="first">C</span>OMPETITION TIMELINE</div>
          <div class="title-sub"><span>奖项设置<img src="~@/assets/img/sign/you.svg" height="24"/></span><span class="line"></span><span class="number">04</span></div>
        </div>
        <div class="content4" v-if="0">
          <div class="setting">
            <div class="list">
              <div class="name name-bg1">金奖</div>
              <div class="subname">获奖证书</div>
              <div class="subname">优秀指导老师讲</div>
              <div class="total total-bg1">共11名</div>
            </div>
            <div class="list">
              <div class="name name-bg2">金奖</div>
              <div class="subname">获奖证书</div>
              <div class="subname">优秀指导老师讲</div>
              <div class="total total-bg2">共11名</div>
            </div>
            <div class="list">
              <div class="name name-bg3">金奖</div>
              <div class="subname">获奖证书</div>
              <div class="subname">优秀指导老师讲</div>
              <div class="total total-bg3">共11名</div>
            </div>
          </div>
          <div class="setting-line1">
            <div class="tag"><span class="title">优秀奖</span>优秀奖证书<span class="total">共114名</span></div>
          </div>
          <div class="setting-line2">
            <div class="tag"><span class="title">入围奖</span>入围证书<span class="total">共180名</span></div>
          </div>

          <div class="setting-line3">
            入围前180件作品按照票数由高到低以实物形式参加线下展览及最终评审，目所有证书均由中国工艺美术学会加善公意并认证
          </div>
        </div>
        <div class="content4">
          <div><img src="~@/assets/img/sign/setting.svg"/> </div>

          <div class="setting-line3">
            入围前180件作品按照票数由高到低以实物形式参加线下展览及最终评审，目所有证书均由中国工艺美术学会加善公意并认证
          </div>
        </div>
      </div>
    </div>


    <div class="grad-content">
      <div class="title">
        <div class="title-letter"><span class="first">C</span>ALL FOR ENTRIES</div>
        <div class="title-sub"><span>作品征集<img src="~@/assets/img/sign/you.svg" height="24"/></span><span class="line"></span><span class="number">05</span></div>
      </div>
      <div class="content5">
        <div class="text"><span>(一) 征集对象：</span>
          大赛作品来源于全国超百所高等院校2025年工艺美术类优秀毕业作品，包括专科、本科、研究生(硕土、博士)毕业生。
        </div>
        <div class="text"><span>(二) 征集门类：</span>
          包括但不限于陶瓷艺术、金属艺术、玻璃艺术、纤维艺术、雕刻艺术、漆艺术、首饰艺术、文创设计等其他工艺美术形态的原创作吧。
        </div>
        <div class="text"><span>(三) 参赛者承诺：</span>
          作品要求:内容健康向上，体现新材料、新工艺、新理念，突出作品的原创性、创新性、艺术性和引领性，具有学术价值，注重作品的当代价值。
        </div>
        <div class="text"><span>(四) 作品形式：</span>
          参赛作品必须是已制作完成的实物作品照片，不接受效果图等虚拟形态的作品。
        </div>
        <div class="text"><span>(五) 作品尺寸：</span>
          <br>1、参赛作品装框后最长边尺寸不得超过 200cm，重量不得超过 120kg。<br>2、含有易碎易折损材料作品入选后，作者需自行将作品送达展馆安装和撤展
        </div>
      </div>

      <div class="title">
        <div class="title-letter"><span class="first">C</span>ALL FOR ENTRIES</div>
        <div class="title-sub"><span>报送方式<img src="~@/assets/img/sign/you.svg" height="24"/></span><span class="line"></span><span class="number">06</span></div>
      </div>
      <div class="content6">
        <div class="text">
          为保障评审工作顺利进行，各参赛院校负责人于2025年6月30日前，组织、协助本校相关专业毕业生通过报名链接自愿上传参赛作品。请各院校负责人使用指定账号密码登录后台网站，对本院校提交的作品进行推送。此次推送内容将作为组委会初次评委评审的重要依据。
        </div>
        <div class="line" @click="handleClickDownload()"><span>下载原创承诺书</span></div>
        <div class="line cns">请提前下载并完整填写《原创承诺书》，在提交报名时一并上传</div>
        <div class="line"><img src="~@/assets/img/sign/xia.svg" width="20"/></div>
        <div class="line fontBg">图片要求</div>
        <div class="line">分辨率要求为300-500dpi，JPG格式，每件(组)作品至少三张照片，包含细节图、整体图、正视图。</div>
        <div class="line"><img src="~@/assets/img/sign/xia.svg" width="20"/></div>
        <div class="line fontBg">详细要求</div>
        <div class="line yq">
          1、提交作品需避免单独媒体显示器，作为展陈必需品。如果需要单独额外设备展示(包含除展柜外的其他展陈需求)，需要作者随作品自行快递至展陈地址。
        </div>
        <div class="line yq">2、作品效果展示若需灯光配合及用电需求，需在作品报名时正确勾选并详细说明。</div>
        <div class="line yq">3、作品安装如需悬空展示，需提交作品展示多角度示例照片，明确三视图，确定吊点、占地面积及具体尺寸</div>
        <div class="line yq">4、若作品展示需进行现场组装，作者需随作品寄送展品安装视频全流程。</div>
        <div class="line fontBg">组委会联系人</div>
        <div class="line">刘茜茜:13949085931</div>
        <div class="line">姚妞妞:18611607763</div>
        <div class="line"><img src="~@/assets/img/sign/xia.svg" width="20"/></div>
        <div class="line" @click="handleClickToSign(3)"><span class="but" >立即报名</span></div>
        <div class="line fontSt">评审结果将在评审结束后，通过教育工作委员会邮箱发送，请注意查看邮箱内信息</div>
      </div>

      <div class="title">
        <div class="title-letter"><span class="first">C</span>ALL FOR ENTRIES</div>
        <div class="title-sub"><span>评分标准<img src="~@/assets/img/sign/you.svg" height="24"/></span><span class="line"></span><span class="number">07</span></div>
      </div>
      <div class="content7">
        <div>所有作品须符合“创意工美”或“科技工美”的评审标准:</div>
        <div class="title bg">创意工美</div>
        <div class="list">
          <div class="list-con">
            <div class="subTitle">传承性</div>
            <div>深挖传统工艺美术的文化内涵，注重对优秀传统文化的创造性转化和创新性发展，呈现传统技艺、设计理念、工艺美学等在当代工艺美术中的传承与发展。</div>
          </div>
          <div class="list-con">
            <div class="subTitle">创新性</div>
            <div>汲取当代设计理念，与传统审美情趣相结合，强调时代语境下工艺美术作品美感与实用的统一，创新作品的理念与形式。</div>
          </div>
        </div>
        <div class="list">
          <div class="list-con">
            <div class="subTitle">跨界行</div>
            <div>鼓励在题材、材质、工艺、艺术风格等方面具有创新性的代表性作品，促进不同工艺美术门类之间的跨界实验，探索工艺美术发展的多种可能性。</div>
          </div>
          <div class="list-con">
            <div class="subTitle">时代性</div>
            <div>紧跟时代发展对工艺美术物性进行全新诠释和探索，美术设计理念，实现对工艺美术所传递出的传统价值的超越。</div>
          </div>
        </div>
        <div class="title bg1">科技工美</div>
        <div class="list">
          <div class="list-con">
            <div class="subTitle">媒介创新性</div>
            <div>鼓励3D打印、虚拟现实等新工艺、新材料、新媒介的研究、创作和实践，探索不同领域之间的交互跨界，注重工艺和材料的研发与应用，使工艺美术作品兼具艺术价值与市场价值:。</div>
          </div>
          <div class="list-con">
            <div class="subTitle">设计系统性</div>
            <div>从设计工具的特性、生产工艺的本体属性出发，革新设计方式，强化创意与科技融合、设计与信息统合、设计与制造一体化。</div>
          </div>
        </div>
        <div class="list">
          <div class="list-con">
            <div class="subTitle">工艺持续性</div>
            <div>采用可量化、指标性等工艺与管理方式，促进艺术、工艺与科技一体化，不断推动具有时代特征的新工艺产生与发展，实现“工美智造”。</div>
          </div>
          <div class="list-con">
            <div class="subTitle">应用推广性</div>
            <div>紧跟新时代需求与市场紧密结合，充分发挥当代信息技术和新媒体技术的作用，实现工艺美术的数字化传播发展。。</div>
          </div>
        </div>
      </div>

      <div class="title">
        <div class="title-letter"><span class="first">C</span>ALL FOR ENTRIES</div>
        <div class="title-sub"><span>知识产权<img src="~@/assets/img/sign/you.svg" height="24"/></span><span class="line"></span><span class="number">08</span></div>
      </div>
      <div class="content8">
        <div class="text"><span>(一) 参赛者承诺：</span>
          参赛者提交的参赛作品必须为参赛者本人的原创。若参赛作品设计版权、专利或因其后宣传导致纠纷，主办单位无需承担任何法律责任，一切责任由参赛者自行负责，而且参赛者应赔偿由此给主办单位造成的一切损失。一旦主办单位发现参赛者有抄袭、侵犯他人知识产权的行为。主办单位有权在比赛任一阶段取消其参赛资格。若在比赛结束以后发现参赛者的参赛作品系侵犯他人知识产权，主办单位有权取消其获奖资格，对其所获之奖项有权予以回收，主办单位有权要求参赛者向主办单位赔偿损失，并依法追究参赛者的法律责任。
        </div>
        <div class="text"><span>(二) 参赛者同意：</span>
          作品的著作权归参赛者，并许可主办单位享有使用权，主办单位可以行使包括展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权等权利。主办单位有权在各种宣传活动中免费使用参赛作品的图片、文字等相关数据，并拥有对入围作品相关的媒体宣传、发行汇编及相关的影像权、展示权及获奖作品其他部分版权。
        </div>
      </div>

      <div class="title">
        <div class="title-letter"><span class="first">C</span>ALL FOR ENTRIES</div>
        <div class="title-sub"><span>声明<img src="~@/assets/img/sign/you.svg" height="24"/></span><span class="line"></span><span class="number">09</span></div>
      </div>
      <div class="content9">
        <div class="text">
          大赛主办单位有权在全球所有媒体上印刷、出版和播放入围及获奖作品，不涉及任何商业目的。任何涉及商业目的事宜，仅取决于参赛者的意愿，主办单位不参与其中。本届大赛所有参赛者均视为已阅读并认同本大赛细则。未尽事宜，主办单位有权跟进修改。主办单位对本届大赛的赛事日程安排、作品征集及知识产权归属、评委组织架构、宣传推广方式等拥有官方最终解释权。
        </div>
      </div>

      <div class="title">
        <div class="title-letter"><span class="first">L</span>IST OF PARTICIPATING INSTITUTI</div>
        <div class="title-sub"><span>参赛院校<img src="~@/assets/img/sign/you.svg" height="24"/></span><span class="line"></span><span class="number">10</span></div>
      </div>
      <div class="content10">
        <div class="text">
          第四届全国大学生“毕业季”工艺美术类优秀毕业作品大赛超百所院校名单（按照学校名称笔划排序）
        </div>
        <div class="center">
          <img src="~@/assets/img/sign/school-list.svg" >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {activityDetail, getActivityPlateList, getActivityCategoryList, getWorksList,getRankingList} from "@/api/Vote.js";
import {bannerAreaList} from "@/api/CourseCenter";
import {mapGetters} from "vuex";
import axios from 'axios';
import { downloadFileByUrl, resolveCommitmentTemplateUrl } from "@/utils/fileDownload";

const DEFAULT_ACTIVITY_ID = 5;
export default {
  name: "workCompetition",
  components: {},
  data() {
    return {
      videoUrl:"https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/%E7%BE%8E%E6%9C%AF%E9%A6%86.mp4",
      activeKey: 0,
      activityId: DEFAULT_ACTIVITY_ID,
      activityObj: {},
      worksList: [],

    };
  },
  computed: mapGetters(["userInfo", "isLogin"]),
  mounted() {

    this.getActivity();
  },
  filters: {
    formatDateYYYYMMDD(value) {
      if (!value) return '';
      const date = new Date(value);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}年${month}月${day}日`;
    },
    daysRemaining(targetTime) {
      if (!targetTime) return 'N/A';
      const targetDate = new Date(targetTime.replace(' ', 'T'));
      const now = new Date();
      const diffMs = targetDate - now;
      const diffDays = Math.ceil(diffMs / 86400000);

      if (diffDays > 0) return `剩余${diffDays}天`;
      if (diffDays === 0) return '今天截止';
      return '已过期';
    }
  },

  methods: {

    getActivity() {
      const activityId = DEFAULT_ACTIVITY_ID;
      activityDetail(activityId, {isShow: 0, uid: this.userInfo.uid | 0}).then(res => {
        this.activityObj = res.data
        this.categoryList=res.data.categoryVos
        this.activityId=res.data.id
      })
    },

    handleClickToSign() {
      this.$router.push("/ContestApply/" + DEFAULT_ACTIVITY_ID);
    },

    async handleClickDownload(){
      try {
        await downloadFileByUrl(
          resolveCommitmentTemplateUrl(this.activityObj),
          '原创承诺书',
          (this.activityObj && this.activityObj.updateTime) || Date.now()
        );
      } catch (error) {
        this.$message.error((error && error.message) || '原创承诺书模板下载失败');
      }
    },

  },
};
</script>

<style lang="scss">
.graduation {
  background: #F7F8FA;
  img{
    z-index: -10;
  }
  .competition-img {
    width: 100%;
    height: auto;
  }
  .course-img {
    width: 100%;
    height: auto;
  }
}

.grad-content {
  margin: 0px auto;
  width: 1280px;
  text-align: left;
  font-size: 16px;
  .title {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 1280px;
    color: #EEEFF0;
    font-size: 24px;
    line-height: 24px;
    font-weight: 900;
    //display: flex;
    //justify-content: space-between;
    .title-letter{
      .first{
        font-size: 36px;
        color:#FCC659;
      }
    }

    .title-sub {
      margin-top: 10px;
      font-size: 28px;
      line-height: 28px;
      font-weight: 900;
      display: flex;
      justify-content: space-between;
      span {
        color: #FE5832;
        img{margin-left: 10px;}
      }
      img{margin-bottom: 4px;}
      .line{
        margin-top: 14px;
        height: 1px;
        background: #FF4115;
        width: 85%;
      }
      .number{
        color: transparent;
        -webkit-text-stroke-width: 1px;
        -webkit-text-stroke-color: #FF4115;
      }

    }


  }

  .content1{
    margin: 0 auto;
    margin-top: 30px;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    height: 425px;
    .left{
      width: 755px;
      background: #DDDDDD;
      border-radius: 10px;
    }
    .right{
      padding:20px;
      width: 400px;
      letter-spacing: 1px; /**字间距*/
      line-height: 2.0;
    }
  }
  .content2{
    margin-top: 30px;
    text-align: center;
    width: 1280px;
    .text{
      color: #000000;
      letter-spacing: 1px; /**字间距*/
      line-height: 2.0;

    }
    .list-img{
      padding:40px;
      margin: 0 auto;
      width: 1000px;
      display: flex;
      justify-content: space-between;
      span{
        width: 400px;
        height: 100px;
        padding:10px 20px;
        img{
          object-fit: scale-down;
        }
        text-align: center;
        color: #FF4115;
        font-size: 20px;
        font-weight: 900;
      }
    }
  }

  .content3{
    margin-top: 30px;
    text-align: center;
    width: 1280px;
    .center{
      padding: 40px 0;
      margin: 20px auto;
    }
  }

  .content5{
    margin-top: 30px;
    text-align: left;
    width: 1280px;
    .text{
      letter-spacing: 1px; /**字间距*/
      line-height: 2.0;
      span{
        color: #333333;
        font-weight: 900;
      }
    }
  }
  .content6{
    margin-top: 30px;
    text-align: center;
    width: 1280px;
    .text{
      text-align: left;
      color: #333333;
      font-weight: 900;
      letter-spacing: 1px; /**字间距*/
      line-height: 1.8;
    }
    .line{
      text-align: center;
      margin: 10px auto;
      span{width:150px;padding:5px 15px;height: 60px;line-height: 40px;font-seize:16px;background:#34D0F4;border-radius: 50px;color: #FFFFFF}
      .but{background:#FE5832;}
    }
    .cns{color:#999999;}
    .yq{text-align: left;color: #333333;font-width: 800;padding: 0 70px 0 70px;}
    .fontBg{color: #34D0F4;font-weight: 900;font-size: 16px;}
    .fontSt{color: #333333;font-weight: 900;}
  }
  .content7{
    margin-top: 30px;
    text-align: left;
    width: 1280px;
    .title{
      text-align: center;
      letter-spacing: 1px; /**字间距*/
      font-size: 24px;
      color:#FE5832;
    }
    .bg{color:#ED001D}
    .bg1{color:#34D0F4}
    .list{
      margin: 0px auto;
      display: flex;
      justify-content: space-between;
      width:1200px;
      .list-con{
        background: #ffffff;
        border-radius: 10px;
        padding:20px;
        width: 580px;
        margin:0px;
        font-size: 14px;
        line-height: 1.8;
        .subTitle{
          color: #000000;
          font-size: 24px;
          font-weight: 900;
          margin-bottom: 10px;
        }
      }
    }
  }

  .content8{
    margin-top: 30px;
    text-align: left;
    width: 1280px;
    .text{
      letter-spacing: 1px; /**字间距*/
      line-height: 1.8;
      span{
        color: #333333;
        font-weight: 900;
      }
    }
  }
  .content9{
    margin-top: 30px;
    text-align: left;
    width: 1280px;
    .text{
      color: #333333;
      font-weight: 900;
      letter-spacing: 1px; /**字间距*/
      line-height: 1.8;
    }
  }

  .content10{
    margin-top: 30px;
    text-align: left;
    width: 1280px;
    .text{
      color: #333333;
      font-weight: 900;
      letter-spacing: 1px; /**字间距*/
      line-height: 1.8;
    }
    .center{
      padding: 20px 0;
      margin: 0px auto;
    }
  }
}

.backgroundFF{
  width: 100%;
  background: #ffffff;
  .grad-con{
    margin: 0px auto;
    padding:1px 0 10px 0;
    width: 1280px;
    text-align: left;
    font-size: 16px;
    .title {
      margin-top: 20px;
      margin-bottom: 20px;
      width: 1280px;
      color: #EEEFF0;
      font-size: 24px;
      line-height: 24px;
      font-weight: 900;
      //display: flex;
      //justify-content: space-between;
      .title-letter{
        .first{
          font-size: 36px;
          color:#FCC659;
        }
      }

      .title-sub {
        margin-top: 10px;
        font-size: 28px;
        line-height: 28px;
        font-weight: 900;
        display: flex;
        justify-content: space-between;
        span {
          color: #FE5832;
          img{margin-left: 10px;}
        }
        img{margin-bottom: 4px;}
        .line{
          margin-top: 14px;
          height: 1px;
          background: #FF4115;
          width: 85%;
        }
        .number{
          color: transparent;
          -webkit-text-stroke-width: 1px;
          -webkit-text-stroke-color: #FF4115;
        }

      }


    }
    .content4{
      margin: 30px auto;
      width: 1050px;
      letter-spacing: 1px; /**字间距*/
      line-height: 1.8;
      text-align: center;
      .setting{
        margin: 20px auto;
        display: flex;
        justify-content: space-between;
        .list{
          width: 340px;height: auto;
          padding:20px;
          border: 1px #dddddd solid;
          border-radius: 10px;
          .name{
            font-size: 18px;
            color: #333333;
            font-weight: 900;
          }
          .name-bg1{
            color: #FE5832;
          }
          .name-bg2{
            color: #98A1BA;
          }
          .name-bg3{
            color: #B96753;
          }
          .subname{
            font-size: 16px;
            color: #333333;
            font-weight: 900;
          }
          .total{
            margin: 10px auto;
            width: 80px;
            padding:5px 10px;
            font-size: 12px;
            color: #333333;
            font-weight: 900;
          }
          .total-bg1{
            background: #FDF0C7;
            border-radius: 50px;
          }
          .total-bg2{
            background: #D7E0F5;
            border-radius: 50px;
          }
          .total-bg3{
            background: #FFE8D6;
            border-radius: 50px;
          }
        }

      }
      .setting-line1{
        background: #FCC659;
        margin: 10px auto;
        text-align: left;
        padding:15px 30px;
        border-radius: 10px;
        font-weight: 900;
        color: #333333;
        .tag{
          .title{font-size: 18px;color: #FF4115;margin-right: 20px}
          .total{
            //background: #FDF0C7;
            color: #ffffff;
            border: 1px #ffffff solid;
            border-radius: 50px;
            margin-left: 10px;
            width: 80px;
            padding:2px 10px;
            font-size: 12px;
          }
        }

      }
      .setting-line2{
        background: #34D0F4;
        margin: 10px auto;
        text-align: left;
        padding:15px 30px;
        border-radius: 10px;
        font-weight: 900;
        color: #333333;
        .tag{
          .title{font-size: 18px;color: #FF4115 ;margin-right: 20px}
          .total{
            color: #ffffff;
            border: 1px #ffffff solid;
            border-radius: 50px;
            margin-left: 10px;
            width: 80px;
            padding:2px 10px;
            font-size: 12px;
          }
        }
      }
      .setting-line3{
        margin: 10px 0 10px 0;
      }
    }
  }
}

@media (max-width: 900px) {
  .graduation {
    overflow-x: hidden;

    img {
      max-width: 100%;
    }

    .competition-img {
      min-height: 160px;
      object-fit: cover;
      object-position: center top;
    }
  }

  .grad-content,
  .backgroundFF .grad-con {
    width: calc(100vw - 24px);
    min-width: 0;
    font-size: 14px;
  }

  .grad-content .title,
  .backgroundFF .grad-con .title {
    width: 100%;
    margin-top: 18px;
    margin-bottom: 14px;
    font-size: 18px;
    line-height: 20px;

    .title-letter .first {
      font-size: 28px;
    }

    .title-sub {
      align-items: center;
      gap: 10px;
      font-size: 22px;
      line-height: 26px;

      span:first-child {
        flex: 0 0 auto;
      }

      .line {
        flex: 1 1 auto;
        width: auto;
        min-width: 36px;
      }
    }
  }

  .grad-content .content1 {
    width: 100%;
    height: auto;
    flex-direction: column;
    gap: 14px;
    margin-top: 18px;

    .left,
    .right {
      width: 100%;
    }

    .left {
      overflow: hidden;
    }

    video {
      width: 100% !important;
      height: auto;
      display: block;
    }

    .right {
      padding: 14px 2px;
      line-height: 1.8;
    }
  }

  .grad-content .content2,
  .grad-content .content3,
  .grad-content .content5,
  .grad-content .content6,
  .grad-content .content7,
  .grad-content .content8,
  .grad-content .content9,
  .grad-content .content10 {
    width: 100%;
    margin-top: 18px;
  }

  .grad-content .content2 .list-img {
    width: 100%;
    padding: 16px 0;
    flex-direction: column;
    gap: 16px;

    span {
      width: 100%;
      height: auto;
      padding: 10px 0;
      font-size: 16px;
    }
  }

  .grad-content .content3 .center,
  .grad-content .content10 .center {
    padding: 12px 0;
    margin: 0 auto;
  }

  .grad-content .content6 {
    .line span {
      display: inline-flex;
      min-height: 34px;
      height: auto;
      line-height: 24px;
      align-items: center;
      justify-content: center;
    }

    .yq {
      padding: 0;
    }
  }

  .grad-content .content7 {
    .title {
      font-size: 20px;
      line-height: 1.4;
    }

    .list {
      width: 100%;
      flex-direction: column;
      gap: 12px;

      .list-con {
        width: 100%;
        padding: 16px;

        .subTitle {
          font-size: 20px;
        }
      }
    }
  }

  .backgroundFF .grad-con .content4 {
    width: 100%;
    margin: 18px auto;

    .setting {
      flex-direction: column;
      gap: 12px;

      .list {
        width: 100%;
      }
    }
  }
}
</style>
